export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-center gap-8 p-8 md:p-10 rounded-2xl bg-background-50 border border-background-200/70">
          <div className="flex-shrink-0 w-24 h-24 rounded-2xl bg-primary-500 flex items-center justify-center">
            <i className="ri-smartphone-line text-4xl text-background-50"></i>
          </div>
          <div className="flex-1 text-center md:text-left">
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">移动端访问入口</h2>
            <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
              黑料平台已适配移动端浏览，在手机浏览器中访问即可获得流畅的移动端体验。
              随时随地查看51黑料最新、91黑料吃瓜、17黑料地址以及718黑料合集，无需下载额外应用。
            </p>
            <div className="mt-4 inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors">
              <i className="ri-qr-scan-line"></i>
              扫码访问移动端
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}